// Expresiones 3D de Noah. El suscriptor elige cómo quiere que Noah se muestre.
export const NOAH_MOODS = {
  happy: { src: '/brand/moods/happy.png', alt: 'Noah celebrando' },
  focused: { src: '/brand/moods/focused.png', alt: 'Noah enfocado' },
  thinking: { src: '/brand/moods/thinking.png', alt: 'Noah pensando' },
  alert: { src: '/brand/moods/alert.png', alt: 'Noah en alerta' },
  search: { src: '/brand/moods/search.png', alt: 'Noah buscando' },
  empty: { src: '/brand/moods/empty.png', alt: 'Noah con una caja vacía' },
  sleep: { src: '/brand/moods/sleep.png', alt: 'Noah descansando' },
  chat: { src: '/brand/moods/chat.png', alt: 'Noah saludando' },
};

// Modos que el suscriptor puede elegir en su perfil
export const EXPRESSION_MODES = [
  { value: 'auto', label: 'Automático', mood: 'chat', desc: 'Noah cambia de expresión según lo que pasa: celebra ventas, se enfoca al escalar.' },
  { value: 'happy', label: 'Entusiasta', mood: 'happy', desc: 'Noah siempre celebra. Ideal si vendes con energía.' },
  { value: 'focused', label: 'Profesional', mood: 'focused', desc: 'Noah serio y directo al cierre.' },
  { value: 'chat', label: 'Cercano', mood: 'chat', desc: 'Noah saluda y conversa. Trato amable.' },
  { value: 'thinking', label: 'Analítico', mood: 'thinking', desc: 'Noah observa y analiza antes de responder.' },
  { value: 'off', label: 'Sin mascota', mood: null, desc: 'Solo iconos, sin ilustraciones de Noah.' },
];

export const DEFAULT_EXPRESSION_MODE = 'auto';

// Devuelve la pose final: en modo auto manda el contexto; en modo fijo manda la elección.
export function resolveMood(contextMood, mode = DEFAULT_EXPRESSION_MODE) {
  if (mode === 'off') return null;
  if (mode === 'auto' || !mode) return NOAH_MOODS[contextMood] ? contextMood : 'chat';
  const preset = EXPRESSION_MODES.find((m) => m.value === mode);
  return preset?.mood || 'chat';
}
